import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

export interface EventOption {
  value: string;
  label: string;
  description: string;
}

export const useEventOptions = (): EventOption[] => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        value: 'dialog:expired',
        label: t('plugins.dialog_expired.label'),
        description: t('plugins.dialog_expired.description'),
      },
      {
        value: 'dialog:insights',
        label: t('plugins.dialog_insights.label'),
        description: t('plugins.dialog_insights.description'),
      },
    ],
    [t]
  );
};
